import { render } from "./EditInserts.vue?vue&type=template&id=7c0518da"
import script from "./EditInserts.vue?vue&type=script&lang=js"
export * from "./EditInserts.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__